import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

import { AccountService } from '@app/_services';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private accountService: AccountService
    ) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        var token;

        if (localStorage.getItem(`${environment.appName}` + 'user')) {
            return true;
            
        } else {
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            localStorage.setItem(`${environment.appName}` + 'user', '')
            return false;
        }
    }
}